export const SERVICE_SELECT_OPTIONS: { value: FilterDimension; text: string }[] = [
  { value: 'totalOrders', text: '下单次数' },
  { value: 'createTime', text: '会员创建时间' },
  { value: 'visitTime', text: '最近到店情况' },
];

export const ORDER_TIMES_OPTIONS: { value: SortOrder; text: string }[] = [
  { value: 'desc', text: '从多到少' },
  { value: 'asc', text: '从少到多' },
];

export const CREATE_TIME_OPTIONS: { value: SortOrder; text: string }[] = [
  { value: 'desc', text: '从近到远' },
  { value: 'asc', text: '从远到近' },
];
export const ARRIVAL_STATUS_OPTIONS: { value: FilterByRecentVisit; text: string }[] = [
  { value: 'today', text: '今天到店' },
  { value: 'yesterday', text: '昨天到店' },
  { value: 'twoDaysAgo', text: '前天到店' },
  { value: 'threeDaysAgo', text: '3天未到店' },
  { value: 'fourDaysAgo', text: '4天未到店' },
  { value: 'fiveDaysAgo', text: '5天未到店' },
  { value: 'sixDaysAgo', text: '6天未到店' },
  { value: 'aWeekAgo', text: '7天未到店' },
  { value: 'moreThanAWeek', text: '超过一周未到店' },
  { value: 'twoWeeksAgo', text: '二周未到店' },
  { value: 'moreThanTwoWeeks', text: '超过二周未到店' },
  { value: 'aMonthAgo', text: '1个月未到店' },
  { value: 'moreThanAMonth', text: '超过1个月未到店' },
];
